<template>
    <span class="d-flex w-100 flex-column">
        <span class="w-100 p-0 m-0 pl-3">
            <span v-if="hasIcon('iconYes') && hasIcon('iconNo')" >
                <b-icon :icon="getIconYes()" :variant="getIconYesColor()" v-if="getValue()" scale="2" />
                <b-icon :icon="getIconNo()" :variant="getIconNoColor()" v-else scale="2"/>
            </span>
            <span v-else>
                <b-icon icon="check" variant="success" v-if="getValue()" scale="2" />
                <b-icon icon="x" variant="danger" v-else scale="2"/>
            </span>
        </span>
        <slot name="secondary">
        </slot>
    </span>
</template>

<script>
    export default {
        name: "BooleanCell",
        props: {
            value: {},
            extraProps: {}
        },
        methods: {
            getValue() {
                return Boolean(this.value)
            },
            hasIcon(icon) {
              return this.extraProps && this.extraProps.hasOwnProperty(icon)
            },
            getIconYes() {
              if (this.hasIcon('iconYes')) {
                return this.extraProps['iconYes']
              }
              return 'check'
            },
            getIconNo() {
              if (this.hasIcon('iconNo')) {
                return this.extraProps['iconNo']
              }
              return 'x'
            },
            getIconYesColor() {
              if (this.hasIcon('iconYes'), this.extraProps.hasOwnProperty('iconYesColor')) {
                return this.extraProps['iconYesColor']
              }
              return 'success'
            },
            getIconNoColor() {
              if (this.hasIcon('iconNo'), this.extraProps.hasOwnProperty('iconNoColor')) {
                return this.extraProps['iconNoColor']
              }
              return 'danger'
            }
        }
    }
</script>

<style scoped>

</style>